import { Link } from "react-router-dom"
import { useAuthStore } from "../../stores/authStore"

const SUPPORT_EMAIL = "info@satelab.org"

// `wide` alinea el pie con el contenido ancho de Inicio y Mis cursos.
export default function Footer({ wide = false }: { wide?: boolean }) {
  const currentYear = new Date().getFullYear()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const linkClass =
    "inline-flex min-h-11 items-center text-sm font-semibold text-muted-foreground transition-colors hover:text-primary sm:min-h-8"

  return (
    <footer className={`section-shell mt-16 pb-8${wide ? " max-w-[110rem]" : ""}`}>
      <div className="flex flex-col gap-3 border-t border-border pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">© {currentYear} SateLab Academy</p>
        <nav aria-label="Enlaces del pie de página" className="flex flex-wrap items-center gap-x-6">
          {/* El catálogo es solo para visitantes sin sesión; con sesión el enlace es Mis cursos. */}
          <Link to={isAuthenticated ? "/mis-cursos" : "/courses"} className={linkClass}>
            {isAuthenticated ? "Mis cursos" : "Catálogo"}
          </Link>
          {isAuthenticated ? (
            <Link to="/ayuda" className={linkClass}>Ayuda</Link>
          ) : (
            <a href={`mailto:${SUPPORT_EMAIL}`} className={linkClass}>Soporte</a>
          )}
          <a href="https://brand.satelab.org" target="_blank" rel="noopener" className={linkClass}>
            Manual de marca<span className="sr-only"> (se abre en una pestaña nueva)</span>
          </a>
          {isAuthenticated && (
            <a href={`mailto:${SUPPORT_EMAIL}`} className={linkClass}>{SUPPORT_EMAIL}</a>
          )}
        </nav>
      </div>
    </footer>
  )
}
